import { render, staticRenderFns } from "./VideoCtas.vue?vue&type=template&id=9c05c976&"
import script from "./VideoCtas.vue?vue&type=script&lang=js&"
export * from "./VideoCtas.vue?vue&type=script&lang=js&"
import style0 from "./VideoCtas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports